import { inject, Injectable } from '@angular/core';

import { SIGNAL_R_PROPERTIES } from '../properties';

import { SignalRService } from '@gan/core/util-signalr';

import { AuthService } from '@gan/common/feature-auth';
import { TrainCardEventInterface } from '../interfaces';

/**
 * train card signalR connection service
 */
@Injectable()
export class TrainCardSignalRService extends SignalRService<TrainCardEventInterface[]> {
  private authService = inject(AuthService);

  hubMethod = SIGNAL_R_PROPERTIES.trainCardsMethod;

  /**
   * start signalR train card hub connection
   */
  override startHubConnection(hubName = SIGNAL_R_PROPERTIES.trainCardsHub) {
    return super.startHubConnection(hubName, this.authService.signalRConnectionOptions);
  }
}
